import { CountryCode, isValidPhoneNumber } from "libphonenumber-js";

import { SearchQuery } from "../services/userServices";

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const PORTAL_COUNTRIES: CountryCode[] = ["SG", "HK", "AE"];

const countryFromRegion = (
  appCountry?: string | null
): CountryCode | undefined => {
  const code = appCountry?.trim().toUpperCase();
  if (code === "UAE") return "AE";
  if (code === "SG" || code === "HK" || code === "AE") return code;
  return undefined;
};

const isPhoneNumber = (value: string, appCountry?: string | null): boolean => {
  if (value.startsWith("+")) return isValidPhoneNumber(value);

  const country = countryFromRegion(appCountry);
  const countries = country ? [country] : PORTAL_COUNTRIES;
  return countries.some((code) => isValidPhoneNumber(value, code));
};

export type UserJumpTarget =
  | { kind: "profile"; userId: string }
  | { kind: "search"; query: SearchQuery };

// GET /users?id= searches the KYC id_number (NRIC, HKID, passport, Emirates ID).
// A user UUID is loaded with GET /users/:userId.
export const buildUserJumpQuery = (
  raw: string,
  appCountry?: string | null
): UserJumpTarget | undefined => {
  const value = raw.trim();
  if (!value) return undefined;

  if (UUID_PATTERN.test(value)) return { kind: "profile", userId: value };

  const region = appCountry ? { appCountry } : {};
  if (value.includes("@"))
    return { kind: "search", query: { email: value, ...region } };

  if (isPhoneNumber(value, appCountry)) {
    return { kind: "search", query: { mobile: value, ...region } };
  }

  return { kind: "search", query: { id: value, ...region } };
};
